import classNames from 'classnames';

import type { PriceProps } from './types';
import './price.scss';

export const Price = ({
  className,
  currency,
  value,
  valueDecimal,
  oldValue,
  period,
  periodMobile,
  sizeLength = value.length,
  oldValuePlacement = 'before',
}: PriceProps) => {
  const oldValueElement = oldValue && (
    <span className="price__old-value">
      {currency}
      {oldValue}
    </span>
  );

  return (
    <div className={classNames('payflow-ui price', className, oldValue && 'has-old-value')}>
      {oldValuePlacement === 'before' && oldValueElement}
      <div className={classNames('price__container', `price-length-${sizeLength}`)}>
        <span className="price__currency">{currency}</span>
        <span className="price__value">{value}</span>
        <span className="price__decimal-and-period">
          {!!valueDecimal && <span className="price__value-decimal">{valueDecimal}</span>}
          {period && (
            <>
              <span className="price__period">{period}</span>
              <span className="price__period-mobile">{periodMobile || period}</span>
            </>
          )}
        </span>
      </div>
      {oldValuePlacement === 'after' && oldValueElement}
    </div>
  );
};
